import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CircularProgress, Container, Grid, MenuItem, Select } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { _BASE_URL, HrRoutes } from '../../Config/Constants';
import HTTPClient from '../../Utils/HTTPClient';
import AddResume from '../Dashboard/Dialogs/AddResume';
import ViewResume from '../Dashboard/Dialogs/ViewResume';
import Header from '../Includes/Header';
import './Hangaround.css';

const STATUS_LIST = {
  notActive: { label: 'Not Active', status: 'notActive', color: '#4caf50' },
  soonActive: { label: '1-30 Days', status: 'soonActive', color: '#edbd22' },
  lessActive: { label: '30+ Days', status: 'lessActive', color: '#ed2222' },
};

const Hangaround = () => {
  const [resumes, setResumes] = useState([]);
  const [hangList, setHangList] = useState([]);
  const [preview, setPreview] = useState(null);
  const [filterValue, setFilterValue] = useState('all');
  const [filterConfig, setFilterConfig] = useState({});
  const [filterLoading, setFilterLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [groupHangaround, setGroupHangaround] = useState([]);
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [resumeSettings, setResumeSettings] = useState({
    openViewResume: false,
    viewResumeLoading: false,
    resumeData: {},
    editId: null,
  });

  const getUserFilter = async () => {
    const _token = sessionStorage.getItem('token');
    let userId = '';
    if (_token) {
      try {
        const tokenArr = JSON.parse(_token);
        userId = tokenArr?.emp;
      } catch (err) {
        console.error('Invalid token format');
        return 'all';
      }
    }

    try {
      const res = await HTTPClient.get(`${HrRoutes.getUserFilter}`, {
        params: { userId },
      });

      if (res.status === 200 && res.data?.filter) {
        return res.data.filter;
      }
    } catch (error) {
      console.warn('Failed to fetch user filter:', error);
    }

    return 'all';
  };

  useEffect(() => {
    // if (visibleGroups.length > 0) {
    //   setExpandedAccordion(visibleGroups[0].index);
    // } else {
    //   setExpandedAccordion(null);
    // }
    //eslint-disable-next-line
    setExpandedAccordion(null);
  }, [filterValue, groupHangaround]);

  const loadHangaround = (selectedFilter = 'all') => {
    setIsLoading(true);

    HTTPClient.get(HrRoutes.hangaroundList, {
      params: {
        searchInDoc: false,
        page: 0,
        rowsPerPage: 50000,
        isHangaround: 'Yes',
      },
    })
      .then((result) => {
        if (result.status !== 200 || !Array.isArray(result.data)) {
          setIsLoading(false);
          return;
        }

        const now = new Date();
        const in30Days = new Date();
        in30Days.setDate(now.getDate() + 30);

        const statusPriority = {
          notActive: 0,
          soonActive: 1,
          lessActive: 2,
        };

        const processed = result.data.map((emp) => {
          if (!emp.hangaround || emp.hangaround.toLowerCase() === '<empty>') {
            emp.hangaround = '<EMPTY>';
          }

          const returnDate = emp.toDate ? new Date(emp.toDate) : null;

          if (!returnDate || returnDate < now) {
            emp.status = STATUS_LIST.notActive;
          } else if (returnDate < in30Days) {
            emp.status = STATUS_LIST.soonActive;
          } else {
            emp.status = STATUS_LIST.lessActive;
          }

          return emp;
        });

        processed.sort((a, b) => {
          const aPriority = statusPriority[a.status?.status] ?? 99;
          const bPriority = statusPriority[b.status?.status] ?? 99;
          return aPriority - bPriority || new Date(a.toDate || 0) - new Date(b.toDate || 0);
        });

        const hangDataGrouped = new Map();
        processed.forEach((emp) => {
          const key = emp.hangaround;
          if (!hangDataGrouped.has(key)) {
            hangDataGrouped.set(key, { label: key, data: [] });
          }
          hangDataGrouped.get(key).data.push(emp);
        });

        hangDataGrouped.forEach((group) => {
          group.data.sort((a, b) => {
            const aPriority = statusPriority[a.status?.status] ?? 99;
            const bPriority = statusPriority[b.status?.status] ?? 99;
            return aPriority - bPriority;
          });
        });

        const groupedArray = Array.from(hangDataGrouped.values());
        setGroupHangaround(groupedArray);
        setResumes(processed);

        const hList = [...new Set(processed.map((emp) => emp.hangaround))];
        hList.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
        setHangList(hList);

        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error loading hangaround data:', error);
        setIsLoading(false);
      });
  };

  const visibleGroups = groupHangaround
    .map((list, index) => {
      const filteredData = list.data?.filter(
        (item) => filterValue === 'all' || item.status?.status === filterValue
      );
      return {
        index,
        label: list.label,
        data: filteredData,
        original: list,
      };
    })
    .filter((group) => group.data && group.data.length > 0 && !group.original.deny);

  const previewProfile = (emp) => {
    HTTPClient.get(HrRoutes.hangaroundEmp(emp.id)).then((result) => {
      if (result.status == 200) {
        setPreview(result.data);
      }
    });
    setPreview(null);
    setResumeSettings({
      openViewResume: true,
      viewResumeLoading: true,
      resumeData: {},
    });
    getSingleResume(emp.id);
  };

  const getSingleResume = (id) => {
    HTTPClient.get(_BASE_URL + '/get-resume/' + id).then((result) => {
      if (result.status == 200) {
        setResumeSettings({
          ...resumeSettings,
          resumeData: result.data,
          openViewResume: true,
          viewResumeLoading: false,
        });
      }
    });
  };

  const handleViewResume = (id) => {
    setResumeSettings({
      openViewResume: true,
      viewResumeLoading: true,
      resumeData: {},
    });
    getSingleResume(id);
  };

  const editResume = (id) => {
    setResumeSettings({
      ...resumeSettings,
      editId: id,
      openViewResume: false,
      openAddResume: true,
    });
  };
  useEffect(() => {
    const init = async () => {
      const savedFilter = await getUserFilter();
      setFilterValue(savedFilter);

      HTTPClient.get(_BASE_URL + '/get-filter-config').then((result) => {
        if (result.status === 200) {
          setFilterConfig(result.data);
          setFilterLoading(false);
        }
      });

      loadHangaround(savedFilter);
    };

    init();
  }, []);
  const getEmpByOccupation = (occ) => {
    const statusPriority = {
      notActive: 0,
      soonActive: 1,
      lessActive: 2,
    };

    let empList = occ.data || [];

    empList.sort((a, b) => {
      const aPriority = statusPriority[a.status?.status] ?? 99;
      const bPriority = statusPriority[b.status?.status] ?? 99;
      return aPriority - bPriority;
    });

    return (
      <Grid
        container
        sx={{ justifyContent: 'center', columnGap: '8px', rowGap: '20px', flexWrap: 'wrap' }}
      >
        {empList.map((emp) => (
          <Grid
            key={emp.id}
            item
            style={{
              width: '12.5%',
              textAlign: 'center',
              marginBottom: '20px',
              paddingLeft: '8px',
            }}
            className="prof-tile"
            onClick={() => previewProfile(emp)}
          >
            <div
              style={{
                fontSize: '10px',
                background: emp.status.color,
                color: '#fff',
                borderRadius: '4px',
                marginBottom: '2px',
              }}
            >
              {emp.status.label}
            </div>

            <div style={{ height: '175px', border: '1px solid #ccc', overflow: 'hidden' }}>
              <img
                src={_BASE_URL + '/' + (emp.photo ? emp.photo : 'no-pic.png')}
                alt="Photo"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
            </div>

            <p
              style={{
                marginBottom: '5px',
                marginTop: '3px',
                fontSize: '17px',
                fontWeight: 'bold',
                textAlign: 'left',
                padding: '5px 8px',
              }}
            >
              {emp.fullName}
              <br />
              <span style={{ fontSize: '17px', fontWeight: 'normal' }}>{emp.note}</span>
            </p>

            <p
              style={{
                fontSize: '15px',
                fontWeight: 'bold',
                textAlign: 'left',
                paddingLeft: '8px',
                paddingRight: '8px',
              }}
            >
              Return Date:
              <br />
              <span style={{ fontSize: '15px', fontWeight: 'normal' }}>
                {emp.toDate ? `${emp.toDate}` : 'Not active'}
              </span>
            </p>
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <>
      <Header />
      <Container
        maxWidth="100%"
        className="settings-container"
        style={{ marginTop: '70px', background: '#eee', minHeight: '100vh', padding: '20px' }}
      >
        <Grid container justifyContent="flex-end" spacing={2}>
          <Grid item>
            <Select
              value={filterValue}
              onChange={(e) => {
                const selected = e.target.value;
                setFilterValue(selected);
                loadHangaround(selected);

                const _token = sessionStorage.getItem('token');
                let userId = '';
                if (_token) {
                  try {
                    const tokenArr = JSON.parse(_token);
                    userId = tokenArr?.emp;
                  } catch (err) {
                    console.error('Invalid token format');
                    return;
                  }
                }

                HTTPClient.post(`${HrRoutes.updateTripFilter}`, {
                  userId,
                  filter: selected,
                })
                  .then((res) => console.log('Filter saved:', res.data))
                  .catch((err) => console.error('Error saving filter:', err));
              }}
              size="small"
              variant="outlined"
              style={{
                width: '150px',
                background: '#fff',
                lineHeight: '1.1em',
                borderRadius: '20px',
                marginTop: '10px',
              }}
            >
              <MenuItem value="all">All</MenuItem>
              {Object.keys(STATUS_LIST).map((key) => (
                <MenuItem key={key} value={STATUS_LIST[key].status}>
                  {STATUS_LIST[key].label}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>

        {isLoading ? (
          <div style={{ padding: 30, textAlign: 'center' }}>
            <CircularProgress />
          </div>
        ) : visibleGroups.length > 0 ? (
          visibleGroups.map((group) => (
            <Accordion
              key={group.index}
              expanded={expandedAccordion === group.index}
              onChange={() =>
                setExpandedAccordion(expandedAccordion === group.index ? null : group.index)
              }
              style={{ marginTop: '10px' }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${group.index}-content`}
                id={`panel${group.index}-header`}
              >
                <Typography component="h2" style={{ fontWeight: 'bold' }}>
                  {group.label === '<EMPTY>' ? 'No Hangaround' : group.label}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {getEmpByOccupation({ ...group.original, data: group.data })}
              </AccordionDetails>
            </Accordion>
          ))
        ) : (
          <Typography variant="body1" style={{ marginTop: '20px', textAlign: 'center' }}>
            No hangaround data available.
          </Typography>
        )}
      </Container>

      {resumeSettings.openViewResume && (
        <ViewResume
          searchTerm={''}
          searchArray={[]}
          editResume={editResume}
          handleViewResume={handleViewResume}
          openViewResume={resumeSettings.openViewResume}
          closeAddResume={() =>
            setResumeSettings({ openViewResume: false, viewResumeLoading: true, resumeData: {} })
          }
          viewResumeLoading={resumeSettings.viewResumeLoading}
          hangaround={preview}
          closeViewResume={() =>
            setResumeSettings({ openViewResume: false, viewResumeLoading: true, resumeData: {} })
          }
          resume={resumeSettings.resumeData}
        />
      )}

      {resumeSettings.openAddResume && (
        <AddResume
          openAddResume={resumeSettings.openAddResume}
          closeAddResume={() =>
            setResumeSettings({ openAddResume: false, resumeData: {}, openViewResume: false })
          }
          addResumeLoading={resumeSettings.addResumeLoading}
          filterConfig={filterConfig}
          filterLoading={false}
          refreshResume={() => {
            setResumeSettings({
              ...resumeSettings,
              editId: false,
              openAddResume: false,
              resumeData: {},
              openViewResume: false,
            });
            loadHangaround();
          }}
          resumeData={resumeSettings.resumeData}
          editId={resumeSettings.editId}
        />
      )}
    </>
  );
};

export default Hangaround;
